<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds"
>
  @if (loading) {
    <div class="absolute top-0 left-0 flex h-full w-full items-center justify-center bg-black/20">
      <flx-spinner [size]="'small'"></flx-spinner>
    </div>
  }

  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    {{ modalTitle() }}
  </div>

  <div
    [formGroup]="enumerationForm"
    (submitForm)="submitModal()"
    class="flx-modal-body"
    flxEnterSubmitForm
  >
    <flx-input class="flx-ds w-full">
      <flx-label class="flx-ds mandatory">Name</flx-label>
      <input
        [formControl]="enumerationNameFC"
        data-testId="new-enumeration-name-input"
        flxAutofocus
        flxInput
        placeholder="Enumeration name"
      />
      @if (enumerationNameFC.touched && enumerationNameFC.errors?.required) {
        <flx-error>Name is required</flx-error>
      } @else if (enumerationNameFC.errors?.pattern) {
        <flx-error>You can only use letters, numbers and characters [] () . _ -</flx-error>
      }
    </flx-input>
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        data-testId="cancel-button"
        flxButton
        type="button"
        variant="ghost"
      >
        Cancel
      </button>
      <button
        [disabled]="readOnly || enumerationForm.invalid"
        (click)="submitModal()"
        class="flx-ds primary"
        data-testId="create-item-button"
        flxButton
        type="button"
      >
        {{ saveButton }}
      </button>
    </div>
  </div>
</flx-modal>
